import React from "react";
import ShopFloor from "../components/production/shopfloor/ShopFloor";

export default function ShopFloorPage() {
  return <ShopFloor />;
}
